import {ref, getCurrentInstance} from "@vue/composition-api";

export function useDeviceMessages(translations) {
  const loading = ref(false);
  const vm = getCurrentInstance();
  const proxy = vm.root.proxy;

  const confirmActionAlert = async (device, action = null) => {
    const $swal = proxy?.$swal;
    if (!$swal) return;

    const titleSwal = getTitleSwal(device, action);
    const confirmButton = getTitleConfirmButton(device, action);

    return await $swal({
      title: titleSwal,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmButton,
      cancelButtonText: translations["actions.cancel"],
      customClass: {
        confirmButton: "btn btn-primary text-capitalize",
        cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
      },
      buttonsStyling: false,
    });
  };

  const successAlertAction = async function (device, action = null) {
    const $swal = proxy?.$swal;
    if (!$swal) return;

    let {device_type, status, text} = device;
    let titleConfirm = '';
    let textConfirm = '';

    if (device_type === 'area') {
      titleConfirm = status === 'ARMED'
        ? translations["messages.desactivate.disarmed_correctly"]
        : translations["messages.activate.armed_correctly"];
    } else {
      titleConfirm = replacePlaceholders(
        translations["bosch.messages.commandExecutedSuccess"] || "Comando %command% ejecutado correctamente",
        {command: action?.name || ""}
      );
    }

    await $swal({
      title: titleConfirm,
      text: textConfirm,
      icon: "success",
    });
  }

  const errorAlertAction = async function (device, message = null,) {
    const $swal = proxy?.$swal;
    if (!$swal) return;

    const messageError = message || (device.active
      ? translations["messages.desactivate.error"]
      : translations["messages.activate.error"]);

    return await $swal({title: 'Error', text: messageError, icon: "error"});
  }

  const showToast = (status, device, loadingToast) => {
    const message = translations["messages.processing"] || "Procesando...";

    if (loadingToast && loadingToast.show) {
      loadingToast.show(translations["messages.loading.title"] || "Cargando", `${message} ${device.text}`, "secondary");
    }
  };

  const getTitleSwal = (device, action = null) => {
    let {status, device_type, text} = device;
    let isAreaDevice    = (device_type === 'area');
    let isOutputDevice  = (device_type === 'output');
    let isDoorDevice    = (device_type === 'door');
    let deviceType      = translations[device_type] || device_type;

    let placeholders = {
      action: '',
      device_type: deviceType,
      device: text
    }

    placeholders.action = (action) ?  (translations[action.name] || action.name ) : '';

    if (isAreaDevice) {
      placeholders.action = (status === 'ARMED') ? translations['disarm'] : translations['arm'];
    } else if (isOutputDevice || isDoorDevice) {
      placeholders.device_type = '';
    }

    return replacePlaceholders(
      translations["bosch.messages.areYouSure"] || "¿Estás seguro de %action% %device_type% %device%?",
      placeholders
    )
  };

  const getTitleConfirmButton = (device, action = null) => {
    return device.status === "enabled"
      ? translations["messages.desactivate.confirm"]
      : translations["messages.activate.confirm"];
  };

  const replacePlaceholders = (template, values) => {
    if (!template) return '';
    return template.replace(/%(\w+)%/g, (match, key) => {
      return values.hasOwnProperty(key) ? values[key] : match;
    });
  }

  return {
    confirmActionAlert,
    successAlertAction,
    errorAlertAction,
    showToast,
    loading
  };
}
